import useAxios from 'hooks/useAxios';

export async function getAvatars() {
  const api = useAxios();

  try {
    const res = await api.get('/avatars');
    return res;
  } catch (err) {
    return err;
  }
}
